import React, { Component } from 'react';
import PropTypes from 'prop-types';

import {RS} from "../../../data/strings/global";
import * as SC from "../../../data/strings/RCStringConst";

import PrecisionIcon from "../../../img/precision.png";
import PowerChange from "../../../img/powerChange.png";
import banner from "../../../img/banner.jpg"

import TBox from "../../common/TBox";
import TButton from "../../common/TButton";

import * as Theme from "../../../app/Theme";

import * as rcc from "../NonVisual/RCConst";

class RCWelcomeForm extends Component {

    static propTypes = {

        onPageChange        : PropTypes.func,
        onQ1Answered        : PropTypes.func,
        onSideBarArrowClick : PropTypes.func,

    };

    static defaultProps = {

        onPageChange        : () => console.log("onPageChange"),
        onQ1Answered        : () => console.log("onQ1Answered"),
        onSideBarArrowClick : () => console.log("onSideBarArrowClick"),
    };

    state = {
        screenSize    : window.innerWidth
    };

    componentDidMount() {
        window.addEventListener("resize", this.onResize);
    };

    componentWillUnmount() {
        window.removeEventListener('resize', this.onResize);
    };

    constructor(props) {

        super(props);

        this.state = {

            //answer1ByteLocal : this.props.answer1Byte,

        };

    };

    onResize = () => {
        this.setState({
            screenSize: window.innerWidth
        });
    };

    onWelcomeFormNextBtnClick = (q1Answer) => {

        try {

            this.props.onQ1Answered(q1Answer, () => {

                this.props.onSideBarArrowClick(true, () => {

                    this.props.onPageChange(rcc.selectIndicatorsForm);

                });

            });

        }
        catch (exception) {

            alert(exception.name + ': ' + exception.message);

        }

    };

    onPrecisionNextBtnClick = () => {



    };

    onPrecisionNextBtnClick = () => {



    };

    renderBannerImage = () => {
        let styles = {
            imgDiv :{
                position: 'fixed',
                top: '-50%',
                left: '-50%',
                width: '200%',
                height: '200%'
            },

            img : {
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                margin: 'auto',
                minWidth: '50%',
                minHeight: '50%',
            }
        };

        return (
            <div style={styles.imgDiv}>
                <img style={styles.img} src={banner} alt='' />
            </div>
        );
    };

    render() {

        const modDivMargin = 15;

        const modDivWidth = 380;
        const modDivHeight = 400;

        const modDivStyle = {
            backgroundColor : Theme.whiteColor,
            borderColor     : Theme.whiteColor, //Theme.HL_PalatinatePurple,
            borderRadius    : 5,
            borderStyle     : "solid",
            borderWidth     : 2,
            height          : modDivHeight,
            width           : modDivWidth,
        };

        /* Change the height here to add/remove space between the icon + title + description and the button. */
        const modDivUpperBoxStyle = {
            height : 310,
            width  : modDivWidth - (modDivMargin * 2),
            marginTop : -25
        };

        const modDivEnterBtnBoxStyle = {
            height : modDivHeight - modDivUpperBoxStyle.height -40,
            width  : modDivWidth - (modDivMargin * 2),
        };

        /* Unfortunately, we can't just grab the height of the button from the button and do 1/2 height of
           the button's container - 1/2 height of the button. */
        const modDivEnterBtnTop = 10;

        const welcomeText =
            <h1
                key   = {"welcomeText"}
                style = {{
                    color : Theme.whiteColor,
                    lineHeight : 1,
                    marginTop : 0
                }}
            >
                {RS(SC.GB_stWelcomeToAppTitle)}
            </h1>;


        const toolDescriptionText =
            <h3
                key   = {"toolDescriptionText"}
                style = {{
                    color : Theme.whiteColor,
                }}
            >
                {RS(SC.GB_stToolDescription)}
            </h3>;

        // A tool to guide you through sample size calculations.

        const instructionsText =
            <h3
                key   = {"instructionsText"}
                style = {{
                    color     : Theme.whiteColor,
                    marginTop : 30,
                }}
            >
                {RS(SC.GB_stChooseOption)}
            </h3>;

        const textDiv =
            <div
                key   = {"textDiv"}
                style = {{
                    color      : Theme.whiteColor,
                    fontFamily : Theme.fontFamily,
                    textAlign  : "center",
                    // backgroundColor: 'rgba(62, 62, 60, .7)',
                    //backgroundColor: 'rgba(63, 82, 80, .7)',
                    backgroundColor: 'rgba(63, 82, 80, .8)',
                    position: 'relative',
                    paddingTop: 25,
                    paddingBottom: 25,
                    marginBottom: 25,
                    marginLeft : 25,
                    marginTop: (window.innerWidth > rcc.smallScreen) ? 25 : 50,
                    marginRight: (window.innerWidth > rcc.mediumScreen) ? 25 : 5
                }}
            >
                {welcomeText}

                <div
                    key   = {"textInnerDiv"}
                    style = {{
                        marginLeft  : 25,
                        marginRight : 25,
                        textAlign   : "left",
                    }}
                >
                    {toolDescriptionText}
                </div>

                {instructionsText}
            </div>;

        const precisionIconBox =
            <TBox
                content         = {[
                    <img
                        src = {PrecisionIcon}
                        alt = {""}
                    />
                ]}
                key             = {"precisionIconBox"}
                justifyContent  = {"flex-end"}
                style           = {{
                    width   : modDivWidth - 30,
                }}
            />;

        const precisionLab =
            <h2
                key   = {"precisionLab"}
                style = {{
                    color     : Theme.RC_HippieBlue,
                    marginTop : 10
                }}
            >
                {RS(SC.GB_stPrecBasedOption)}
            </h2>;

        const precisionDescriptionLab =
            <h4
                key   = {"precisionDescriptionLab"}
                style = {{
                    fontWeight : "normal",
                    marginTop  : 0,
                }}
            >
                {RS(SC.GB_stPrecBasedOptionDescription)}
            </h4>;

        // The allowable or acceptable error in estimates.

        let precisionUpperBoxContent = [];
        precisionUpperBoxContent.push(precisionIconBox);
        precisionUpperBoxContent.push(precisionLab);
        precisionUpperBoxContent.push(precisionDescriptionLab);

        const precisionUpperBox =
            <TBox
                alignItems     = {"flex-start"}
                content        = {precisionUpperBoxContent}
                key            = {"precisionUpperBox"}
                flexDirection  = {"column"}
                justifyContent = {"flex-start"}
                style          = {{
                    ...modDivUpperBoxStyle,
                }}
            />;

        const precisionNextBtn =
            <TButton
                caption        = {RS(SC.GB_stNext)}
                onClick        = {() => this.onWelcomeFormNextBtnClick(rcc.precisionAQ2A)}
                color          = {"secondary"}
                containerStyle = {{
                    ...modDivEnterBtnBoxStyle,
                }}
                key            = {"precisionNextBtn"}
                style = {{
                    backgroundColor : Theme.RC_HippieBlue,
                    color           : Theme.whiteColor,
                    top             : modDivEnterBtnTop,
                    width           : Theme.navBtnWidth,
                }}
            />;

        let precisionNextBtnBoxContent = [];
        precisionNextBtnBoxContent.push(precisionNextBtn);

        const precisionNextBtnBox =
            <TBox
                content = {precisionNextBtnBoxContent}
                key     = {"precisionNextBtnBox"}
            />;

        let precisionBoxContent = [];
        precisionBoxContent.push(precisionUpperBox);
        precisionBoxContent.push(precisionNextBtnBox);

        const precisionBox =
            <TBox
                content        = {precisionBoxContent}
                flexDirection  = {"column"}
                key            = {"precisionBox"}
                style          = {{
                    ...modDivStyle,
                    margin : 25, // needed to prevent boxes from clashing when window is resized and to keep them aligned relative to each other
                    marginRight: 50
                }}
            />;

        const powerChangeIconBox =
            <TBox
                content        = {[
                    <img
                        src = {PowerChange}
                        alt = {""}
                    />
                ]}
                justifyContent = {"flex-end"}
                key            = {"powerChangeIconBox"}
                style          = {{
                    width   : modDivWidth - 30,
                }}
            />;

        const powerChangeLab =
            <h2
                key            = {"powerChangeLab"}
                style = {{
                    color     : Theme.RC_HippieBlue,
                    textAlign : "left",
                    marginTop : 10
                }}
            >
                {RS(SC.GB_stPowerBasedOption)}
            </h2>;

        const powerChangeDescriptionLab =
            <h4
                key   = {"powerChangeDescriptionLab"}
                style = {{
                    fontWeight : "normal",
                    marginTop  : 0,
                    textAlign  : "left",
                }}
            >
                {RS(SC.GB_stPowerBasedOptionDescription)}
            </h4>;

        //The minimum difference between two groups or time points detected by surveys.

        let powerChangeUpperBoxContent = [];
        powerChangeUpperBoxContent.push(powerChangeIconBox);
        powerChangeUpperBoxContent.push(powerChangeLab);
        powerChangeUpperBoxContent.push(powerChangeDescriptionLab);

        const powerChangeUpperBox =
            <TBox
                alignItems     = {"flex-start"}
                content        = {powerChangeUpperBoxContent}
                justifyContent = {"flex-start"}
                flexDirection  = {"column"}
                key            = {"powerChangeUpperBox"}
                style          = {{
                    ...modDivUpperBoxStyle,
                }}
            />;

        const powerChangeNextBtn =
            <TButton
                caption        = {RS(SC.GB_stNext)}
                color          = {"secondary"}
                onClick        = {() => this.onWelcomeFormNextBtnClick(rcc.powerChangeQ1B)}
                containerStyle = {{
                    ...modDivEnterBtnBoxStyle,
                }}
                key            = {"powerChangeNextBtn"}
                style = {{
                    backgroundColor : Theme.RC_HippieBlue,
                    color           : Theme.whiteColor,
                    top             : modDivEnterBtnTop,
                    width           : Theme.navBtnWidth,
                }}
            />;

        let powerChangNextBtnBoxContent = [];
        powerChangNextBtnBoxContent.push(powerChangeNextBtn);

        const powerChangeNextBtnBox =
            <TBox
                content = {powerChangNextBtnBoxContent}
                key     = {"powerChangeNextBtnBox"}
            />;

        let powerChangeBoxContent = [];
        powerChangeBoxContent.push(powerChangeUpperBox);
        powerChangeBoxContent.push(powerChangeNextBtnBox);

        const powerChangeBox =
            <TBox
                content        = {powerChangeBoxContent}
                flexDirection  = {"column"}
                key            = {"powerChangeBox"}
                style          = {{
                    ...modDivStyle,
                    margin : 25, // needed to prevent boxes from clashing when window is resized and to keep them aligned relative to each other
                    marginRight: 50
                }}
            />;

        let q1BoxContent = [];
        q1BoxContent.push(precisionBox);
        q1BoxContent.push(powerChangeBox);

        const q1Box =
            <TBox
                content = {q1BoxContent}
                key     = {"q1Box"}
            />;

        return (
            <React.Fragment>

                {this.renderBannerImage()}
                {textDiv}
                {q1Box}

            </React.Fragment>

        );

    }

}

export default RCWelcomeForm;
